module.exports = __webpack_public_path__ + "static/img/12.b448371.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/12.png
// module id = 7yJJ
// module chunks = 0